<div class="white-box" [ngClass]="{ active: activeTab }">
  <p>{{ title | translate }}</p>
  <span class="icon-i-arrow-forward"></span>
</div>
